import React from 'react';
import { useSelector } from 'react-redux';
import Price, {
  PRICE_COLOR,
  PRICE_SIZE,
  PRICE_DECORATION,
} from '@bit/gerenciatd.unifiedcomponents.price';
import Call4Selling from '@bit/gerenciatd.unifiedcomponents.call4-selling';
import Button, {
  BUTTON_COLOR,
  BUTTON_HEIGHT,
  BUTTON_WIDTH,
} from '@bit/gerenciatd.unifiedcomponents.button';
import TextInfo, {
  KIND_TEXT,
  COLOR,
  ALIGN,
  SIZE,
  FONT_TYPE,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import { BUTTON_CONTENT } from '@bit/gerenciatd.utils.tagging';

import './StickyBar.scss';

const call4SellingProps = {
  color: 'green_reverse',
  kind: 'c2c',
  view: 'button',
  print900: false,
  label: 'Te llamamos',
  level: 2,
  fontType: 'light',
};

/**
 * componente funcinoal para renderizar la sticky bar con el precio
 * @param {object} info info del producto
 * @param {object} taggingInfo info de taggeo
 * @param {string} downGradeButtonLink link para el downgrade
 * @param {function} downgradeOnClick funcion a ejecutar para el downgrade
 * @param {bool} isLanding flag para si es landing
 * @param {bool} hideCallMeButton flag para ocultar el callmeButton
 * @returns {jsx}
 */
const StickyBar = ({
  info,
  taggingInfo,
  downGradeButtonLink,
  downgradeOnClick,
  isLanding,
  hideCallMeButton,
}) => {
  const { blockMeInteresa } = useSelector((state) => state.fusion);
  const shouldRedirectConfirmation = downGradeButtonLink && downGradeButtonLink.includes('confirmacion');
  const selectedProduct = info;

  const stickyButtonLink = () => {
    let linkRespuesta = '';
    if (
      isLanding
      && selectedProduct
      && selectedProduct.dataMap
      && selectedProduct.dataMap.urlProdCompra
    ) {
      linkRespuesta = `${selectedProduct.dataMap.urlProdCompra}&pid=clic-boton-meinteresa-flyout`;
    } else if (downGradeButtonLink) {
      linkRespuesta = downGradeButtonLink;
    }
    return linkRespuesta;
  };

  return (
    <div className="sticky-flyout">
      <div className="sticky-flyout__price-area">
        {selectedProduct.dataMap && selectedProduct.dataMap.pvpTachado && (
          <Price
            amount={selectedProduct.dataMap.pvpTachado}
            unity="€"
            color={PRICE_COLOR.GREY_5}
            size={PRICE_SIZE.REGULAR}
            decoration={PRICE_DECORATION.LINE_THROUGH}
          />
        )}
        <Price
          amount={selectedProduct.dataMap.pvp}
          unity={selectedProduct.dataMap.unidad}
          color={PRICE_COLOR.ORANGE}
          size={
            selectedProduct.dataMap.pvpTachado
              ? PRICE_SIZE.SMALL
              : PRICE_SIZE.REGULAR
          }
        />
        {selectedProduct.dataMap && selectedProduct.dataMap.subidaPVP && selectedProduct.dataMap.subidaPVP === 'true' && (
          <TextInfo
            className="pvpException"
            text="*"
            kind={KIND_TEXT.PARAGRAPH}
            align={ALIGN.LEFT}
            color={COLOR.GREY_6}
            size={SIZE.TITLE6}
            fontType={FONT_TYPE.REGULAR}
          />
        )}
      </div>
      <div className="sticky-flyout__button-area">
        <div>
          <Button
            forceExternal={!shouldRedirectConfirmation}
            target="_self"
            color={BUTTON_COLOR.GREEN}
            taggingInfo={{
              ...taggingInfo,
              componentContent: BUTTON_CONTENT.CTA,
              componentPerso: '',
            }}
            label="Me interesa"
            onClick={downgradeOnClick}
            link={stickyButtonLink()}
            disable={blockMeInteresa}
            // link={`${selectedProduct.dataMap.urlProdCompra}&pid=clic-boton-meinteresa-flyout`}
            size={{
              w: BUTTON_WIDTH.MEDIUM,
              h: BUTTON_HEIGHT.REGULAR,
            }}
          />
        </div>
        {!isLanding && !hideCallMeButton && (
          <div>
            <Call4Selling
              {...call4SellingProps}
              taggingInfo={taggingInfo}
              applySam={false}
            />
          </div>
        )}
      </div>
    </div>
  );
};

StickyBar.defaultProps = {
  isLanding: false,
};

export default StickyBar;
